import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function NavBar({ back = '/', home = '/home' }) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isHome = pathname === '/home' || pathname === '/homeinstrutor'

  const NavButton = ({ icon, label, onClick, active = false }) => (
    <button
      onClick={onClick}
      className={`
        flex flex-col items-center justify-center flex-1 py-2
        transition-all duration-200
        ${active ? 'text-primary scale-105' : 'text-gray-500 hover:text-primary'}
      `}
    >
      <span className="material-icons text-xl">{icon}</span>
      <span className="text-[11px] font-medium">{label}</span>
    </button>
  )

  return (
    <div className="fixed bottom-2 sm:bottom-3 left-1/2 -translate-x-1/2 w-full max-w-[500px] px-2 sm:px-3 z-40">
      <div className="relative bg-white/90 backdrop-blur-lg shadow-xl rounded-full flex items-center justify-between px-2 sm:px-3 py-1.5 sm:py-2">

        {/* Left */}
        <NavButton
          icon={isHome ? 'logout' : 'arrow_back'}
          label={isHome ? 'Sair' : 'Voltar'}
          onClick={() => navigate(back)}
        />

        {/* Floating Home */}
        <button
          onClick={() => navigate(home)}
          className="
            absolute left-1/2 -translate-x-1/2 -top-6
            bg-primary text-white w-16 h-16 sm:w-[68px] sm:h-[68px] rounded-full
            flex flex-col items-center justify-center
            shadow-xl hover:scale-105 active:scale-95
            transition-all duration-200 z-20
          "
        >
          <span className="material-icons text-2xl sm:text-3xl">home</span>
          <span className="text-[10px] font-semibold leading-none">Home</span>
        </button>

        {/* Right */}
        <NavButton
          icon="account_circle"
          label="Perfil"
          active={pathname.includes('/perfil')}
          onClick={() => navigate('/perfil')}
        />
      </div>
    </div>
  )
}
